import React, { useState, useEffect } from "react";
import axios from "axios";
import "../components/AdminHub.css";
import noProfile from "../assets/No_Profile.jpg";
import {
  FiRefreshCw,
  FiEdit2,
  FiTrash2,
  FiUserPlus,
  FiSend
} from "react-icons/fi";
import { toast } from "react-toastify";
import PageTitle from "../components/PageTitle";

const BASE_URL = process.env.REACT_APP_API_URL; // Tomará localhost en local y la URL de Render en producción
const API_URL = `${BASE_URL}/api/users`;
const API_NOTIFS = `${BASE_URL}/api/notificaciones`;

function AdminHub() {
  const [users, setUsers] = useState([]);
  const [tituloNotificacion, setTituloNotificacion] = useState("");
  const [notificacion, setNotificacion] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [showNotifModal, setShowNotifModal] = useState(false);
  const [userForm, setUserForm] = useState({
    nombre: "",
    documento: "",
    correo: "",
    area: "",
    cargo: "",
    telefono: "",
    rol: "Suscriptor",
    activo: true,
    foto: noProfile,
  });
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [destino, setDestino] = useState("fonpower");

  // === Cargar usuarios al inicio ===
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsers(res.data);
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    }
  };


  // === Guardar usuario (nuevo o editado) ===
  const handleGuardarUsuario = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

      if (editingUser) {
        await axios.put(
          `${API_URL}/${editingUser}`,
          userForm,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        await axios.post(
          API_URL,
          userForm,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      fetchUsers();
      setShowModal(false);
    } catch (error) {
      console.error("Error al guardar usuario:", error);
    }
  };

  // === Crear nuevo usuario ===
  const handleNuevoUsuario = () => {
    setEditingUser(null);

    setUserForm({
      nombre: "",
      documento: "",
      correo: "",
      area: "",
      cargo: "",
      telefono: "",
      rol: "Suscriptor",
      activo: true,
      foto: noProfile,
    });

    setShowModal(true);
  };

  // === Editar usuario ===
  const handleEditarUsuario = (user) => {
    setEditingUser(user._id);
    setUserForm({
      ...user,
      foto: user.foto || noProfile,
    });
    setShowModal(true);
  };

  // === Subir / reemplazar foto ===
  const handleFotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("foto", file);

    try {
      const url = editingUser
        ? `${API_URL}/upload/${editingUser}`
        : `${API_URL}/upload`;

      const token = localStorage.getItem("token");

      const res = await axios.post(
        url,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setUserForm({ ...userForm, foto: res.data.url });
    } catch (error) {
      console.error("Error al subir la foto:", error);
      toast.error("No se pudo subir la imagen. Intenta de nuevo.");
    }
  };

  // === Enviar notificación ===
  const handleNotificacion = async (e) => {
    e.preventDefault();

    if (!tituloNotificacion.trim() && !notificacion.trim()) {
      return toast.warn("Escribe un título o mensaje antes de enviar.");
    }

    try {
      const res = await axios.post(
        API_NOTIFS,
        {
          title:
            tituloNotificacion ||
            "Mensaje del Administrador",

          message:
            notificacion,

          destino
        }
      );

      if (res.data.success) {
        toast.success("Notificación enviada correctamente a todos los usuarios.");
      } else {
        toast.warn("No se pudo enviar la notificación.");
      }

      setTituloNotificacion("");
      setNotificacion("");
    } catch (error) {
      console.error("❌ Error al enviar notificación:", error);
      toast.error("Error al enviar la notificación. Verifica el servidor.");
    }
  };

  // === Restablecer contraseña (visual) ===
  const handleRestablecerContrasena = async () => {
    if (newPassword !== confirmPassword) {
      return toast.error("Las contraseñas no coinciden");
    }

    if (newPassword.length < 5) {
      return toast.error("La contraseña es demasiado corta");
    }

    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${API_URL}/admin-reset-password/${editingUser}`,
        { nueva: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );


      toast.success("Contraseña restablecida correctamente");

      setShowPasswordModal(false);
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Error al restablecer contraseña:", error);
      toast.error(
        error.response?.data?.message || "Error al cambiar la contraseña"
      );
    }
  };


  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const confirmarEliminacion = async () => {
    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${API_URL}/${userToDelete._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchUsers();
      setShowDeleteModal(false);
      setUserToDelete(null);
    } catch (error) {
      console.error("Error al eliminar usuario:", error);
    }
  };

  const usersOrdenados = [...users].sort((a, b) =>
    (a.nombre || "").localeCompare(
      b.nombre || "",
      "es",
      { sensitivity: "base" }
    )
  );

  return (

    <>

      <PageTitle title="Hub" />

      <div className="adminhub-root">

        <header className="inv-header">
          <h2 className="inv-title">| Hub</h2>

          <div className="inv-actions">

            <button
              className="inv-btn-primary"
              onClick={handleNuevoUsuario}
            >
              <FiUserPlus size={15} />
              Crear usuario
            </button>

            <button
              className="inv-btn-primary"
              onClick={() => setShowNotifModal(true)}
            >
              <FiSend size={15} />
              Enviar notificación
            </button>

          </div>
        </header>

        {/* === TARJETAS KPI (4 tarjetas) === */}
        <div className="adminhub-kpi-grid">

          <div className="kpi-card">
            <h3>Usuarios activos</h3>
            <span>{users.filter(u => u.activo).length}</span>
          </div>

          <div className="kpi-card">
            <h3>Usuarios inactivos</h3>
            <span>{users.filter(u => !u.activo).length}</span>
          </div>

          <div className="kpi-card">
            <h3>Total usuarios</h3>
            <span>{users.length}</span>
          </div>

          <div className="kpi-card">
            <h3>Usuarios en línea</h3>
            <span>—</span>
          </div>

        </div>

        {/* === TABLA DE USUARIOS === */}
        <section className="adminhub-card full">
          <h2>Usuarios</h2>

          <table className="users-table">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Correo</th>
                <th>Celular</th>
                <th>Area</th>
                <th>Cargo</th>
                <th>Rol</th>
                <th>Estado</th>
                <th className="center">Acciones</th>
              </tr>
            </thead>

            <tbody>
              {usersOrdenados.map((u) => (
                <tr key={u._id}>
                  <td className="user-cell">
                    <img src={u.foto || noProfile} alt="" />
                    <div>
                      <strong>{u.nombre}</strong>
                      <small>ID: {u.documento}</small>
                    </div>
                  </td>

                  <td>{u.correo}</td>
                  <td>{u.telefono}</td>
                  <td>{u.area}</td>
                  <td>{u.cargo}</td>
                  <td>{u.rol}</td>

                  <td>
                    <span className={`badge ${u.activo ? "active" : "inactive"}`}>
                      {u.activo ? "Activo" : "Inactivo"}
                    </span>
                  </td>

                  <td className="center actions">
                    <button className="icon-btn" onClick={() => handleEditarUsuario(u)} title="Editar usuario">
                      <FiEdit2 />
                    </button>

                    <button
                      className="icon-btn"
                      onClick={() => {
                        setEditingUser(u._id);   // ← Asignar el usuario antes de abrir modal
                        setShowPasswordModal(true);
                      }}
                      title="Restablecer contraseña"
                    >
                      <FiRefreshCw />
                    </button>

                    <button className="icon-btn" onClick={() => {
                      setUserToDelete(u);
                      setShowDeleteModal(true);
                    }}
                      title="Eliminar usuario">
                      <FiTrash2 />
                    </button>

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* === MODAL CREAR / EDITAR USUARIO === */}
        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal wide" onClick={(e) => e.stopPropagation()}>
              <h3>{editingUser ? "Editar Usuario" : "Crear Usuario"}</h3>

              <form onSubmit={handleGuardarUsuario} className="modal-form new-layout">

                {/* FOTO CENTRADA ARRIBA */}
                <div className="foto-top">
                  <img
                    src={userForm.foto || noProfile}
                    alt="Preview"
                    className="foto-preview-large"
                  />
                  <button
                    type="button"
                    className="inv-btn-primary foto-boton"
                    onClick={() => document.getElementById("fileInput").click()}
                  >
                    Cambiar foto
                  </button>

                  <input
                    id="fileInput"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleFotoChange}
                  />
                </div>

                {/* DOS COLUMNAS */}
                <div className="form-two-cols">

                  <div className="field">
                    <label>Nombre</label>
                    <input
                      type="text"
                      value={userForm.nombre}
                      onChange={(e) => setUserForm({ ...userForm, nombre: e.target.value })}
                      required
                    />
                  </div>

                  <div className="field">
                    <label>Identificación</label>
                    <input
                      type="text"
                      value={userForm.documento}
                      onChange={(e) => setUserForm({ ...userForm, documento: e.target.value })}
                      required
                    />
                  </div>

                  <div className="field">
                    <label>Área</label>
                    <input
                      type="text"
                      value={userForm.area}
                      onChange={(e) => setUserForm({ ...userForm, area: e.target.value })}
                      required
                    />
                  </div>

                  <div className="field">
                    <label>Cargo</label>
                    <input
                      type="text"
                      value={userForm.cargo}
                      onChange={(e) => setUserForm({ ...userForm, cargo: e.target.value })}
                      required
                    />
                  </div>

                  <div className="field">
                    <label>Teléfono</label>
                    <input
                      type="text"
                      value={userForm.telefono}
                      onChange={(e) => setUserForm({ ...userForm, telefono: e.target.value })}
                      required
                    />
                  </div>

                  <div className="field">
                    <label>Correo</label>
                    <input
                      type="email"
                      value={userForm.correo}
                      onChange={(e) => setUserForm({ ...userForm, correo: e.target.value })}
                      required
                    />
                  </div>

                  <div className="field">
                    <label>Rol</label>
                    <select
                      value={userForm.rol}
                      onChange={(e) => setUserForm({ ...userForm, rol: e.target.value })}
                    >
                      <option>admin</option>
                      <option>suscriptor</option>
                    </select>
                  </div>

                  <div className="field">
                    <label>Estado</label>
                    <select
                      value={userForm.activo ? "Activo" : "Inactivo"}
                      onChange={(e) =>
                        setUserForm({
                          ...userForm,
                          activo: e.target.value === "Activo",
                        })
                      }
                    >
                      <option>Activo</option>
                      <option>Inactivo</option>
                    </select>
                  </div>

                </div>

                {/* BOTONES */}
                <div className="modal-actions">
                  <button type="button" className="hub-btn-secondary"
                    onClick={() => setShowModal(false)}>

                    Cancelar
                  </button>
                  <button type="submit" className="hub-btn-primary" >

                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* === MODAL RESTABLECER CONTRASEÑA === */}
        {showPasswordModal && (
          <div className="modal-overlay" onClick={() => setShowPasswordModal(false)}>
            <div className="modal small reset-pass" onClick={(e) => e.stopPropagation()}>
              <h3>Restablecer Contraseña</h3>
              <input
                type="password"
                placeholder="Nueva contraseña"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <input
                type="password"
                placeholder="Confirmar contraseña"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <div className="modal-actions">
                <button className="hub-btn-secondary" onClick={() => setShowPasswordModal(false)}>
                  Cancelar
                </button>
                <button className="hub-btn-primary" onClick={handleRestablecerContrasena}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* === MODAL NOTIFICACIÓN === */}
        {showNotifModal && (
          <div className="modal-overlay" onClick={() => setShowNotifModal(false)}>
            <div className="modal small" onClick={(e) => e.stopPropagation()}>
              <h3>Enviar Notificación</h3>

              <form onSubmit={handleNotificacion} className="modal-form">
                <label>Título</label>
                <input
                  type="text"
                  value={tituloNotificacion}
                  onChange={(e) => setTituloNotificacion(e.target.value)}
                />

                <label>Mensaje</label>
                <textarea
                  rows="3"
                  value={notificacion}
                  onChange={(e) => setNotificacion(e.target.value)}
                />

                <label>Destino</label>

                <select
                  value={destino}
                  onChange={(e) =>
                    setDestino(e.target.value)
                  }
                >

                  <option value="fonpower">
                    Fonpower
                  </option>

                  <option value="gestion360">
                    Gestión360
                  </option>

                  <option value="todos">
                    Ambos
                  </option>

                </select>

                <div className="modal-actions">
                  <button type="button" className="hub-btn-secondary" onClick={() => setShowNotifModal(false)}>
                    Cancelar
                  </button>
                  <button type="submit" className="hub-btn-primary">
                    Enviar
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showDeleteModal && (
          <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
            <div className="modal delete-modal" onClick={(e) => e.stopPropagation()}>

              <h3>¿Deseas eliminar este usuario?</h3>

              <p className="delete-text">
                Esta acción no se puede deshacer. El usuario será eliminado permanentemente
                del sistema.
              </p>

              <div className="modal-actions">
                <button
                  className="hub-btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancelar
                </button>

                <button
                  className="hub-btn-primary"
                  onClick={confirmarEliminacion}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        )}

      </div>

    </>

  );
}

export default AdminHub;
